import { getClassName } from 'common/utils';
import React from 'react';

export interface SkeletonLoaderProps {
  width?: number | string;
  height?: number | string;
  margin?: boolean;
  round?: boolean;
  className?: string;
  children?: React.ReactElement<SkeletonLoaderProps>;
}

function SkeletonLoader({
  width,
  height,
  margin,
  round,
  className,
  children
}: SkeletonLoaderProps) {
  return (
    <div
      className={getClassName(`skeleton-loader ${className}`, { round, margin })}
      style={{
        width,
        height
      }}
    >
      <div className="shimmer" />
      {children}
    </div>
  );
}

export default React.memo(SkeletonLoader);
